import { render, staticRenderFns } from "./GGKit.vue?vue&type=template&id=9a08f150&"
import script from "./GGKit.vue?vue&type=script&lang=js&"
export * from "./GGKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports